import layoutEngine from "../libraries/layoutEngine";
const InstanceManager = {
  // NOT used anymore:
  // instancesByLayer: {},

  getInstances(cellName) {
    const cell = layoutEngine.getCell(cellName);
    return cell?.instances || [];
  },

  addInstance(parentCellName, instanceData) {
    const cell = layoutEngine.getCell(parentCellName);
    if (!cell) return;

    if (!cell.instances) cell.instances = [];
    cell.instances.push(instanceData);
  },

  clearInstances(cellName) {
    const cell = layoutEngine.getCell(cellName);
    if (cell) cell.instances = [];
  }
};

export default InstanceManager;
